'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toastFooterClassNames: function() {
        return toastFooterClassNames;
    },
    useToastFooterStyles_unstable: function() {
        return useToastFooterStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toastFooterClassNames = {
    root: 'fui-ToastFooter'
};
/**
 * Styles for the root slot
 */ const useRootBaseClassName = /*#__PURE__*/ (0, _react.__resetStyles)("r56x6h2", null, [
    ".r56x6h2{padding-top:16px;grid-column-start:2;grid-column-end:3;display:flex;align-items:center;gap:14px;}"
]);
const useToastFooterStyles_unstable = (state)=>{
    'use no memo';
    const rootBaseClassName = useRootBaseClassName();
    state.root.className = (0, _react.mergeClasses)(toastFooterClassNames.root, rootBaseClassName, state.root.className);
    return state;
};
